<template>
  <div class="item-list" :class="[!$route.meta.sidebar ? 'item-list--no-sidebar' : '']">
    <v-item
      v-for="(item, index) in items"
      :key="item.id"
      :index="index"
      :item="item"
      :imgHeight="imgHeight"
      @height="imgHeightCalc($event, index)"/>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  components: {
    'v-item': require('@/components/item.vue').default,
  },
  computed: {
    ...mapState({
      stateItems: state => state.step.items,
      windowWidth: state => state.window.width,
      items(state) {
        if (!state.step.items) return
        let val = state.step.items
        let item = []
        let soldout = []
        let sorted = {}
        let array = []

        val.sort((a, b) => {
          a = Number(a.rank)
          b = Number(b.rank)

          if (a > b){
            return -1
          } else if (a < b){
            return 1
          }
          return 0
        })

        for (var i = 0; i < val.length; i++) {
          if (!val[i].soldout) {
            item.push(val[i])
          } else {
            soldout.push(val[i])
          }
        }

        item = item.concat(soldout)
        console.log(item);

        return item
      },
    })
  },
  data() {
    return {
      imgHeight: {},
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.path !== from.path) {
        this.routeChange()
      }
    },
  },
  methods: {
    imgHeightCalc(val, index) {
      let num = Number(index)
      let target1, target2
      this.$set(this.imgHeight, num, val)

      // 2カラム
      if (this.$route.meta.sidebar || 992 < this.windowWidth >= 768) {
        if ((num % 2) === 0) {
          target1 = num + 1
        } else {
          target1 = num - 1
        }

        if (this.imgHeight[target1]) {
          if (this.imgHeight[num] >= this.imgHeight[target1]) {
            this.$set(this.imgHeight, target1, this.imgHeight[num])
          } else {
            this.$set(this.imgHeight, num, this.imgHeight[target1])
          }
        }
      }
      // 3カラム
      else {
        if ((num % 3) === 0) {
          target1 = num + 1
          target2 = num + 2
        } else if ((num % 3) === 1) {
          target1 = num - 1
          target2 = num + 1
        } else {
          target1 = num - 2
          target2 = num - 1
        }
        if (this.imgHeight[target1] || this.imgHeight[target2]) {
          if (this.imgHeight[num] >= this.imgHeight[target1]) {
            this.$set(this.imgHeight, target1, this.imgHeight[num])
          } else if (this.imgHeight[num] >= this.imgHeight[target2]) {
            this.$set(this.imgHeight, target2, this.imgHeight[num])
          } else if (this.imgHeight[num] < this.imgHeight[target1]) {
            this.$set(this.imgHeight, num, this.imgHeight[target1])
          } else if (this.imgHeight[num] < this.imgHeight[target2]) {
            this.$set(this.imgHeight, num, this.imgHeight[target2])
          }
        }
      }
    },
    routeChange() {
      this.imgHeight = {}
    },
  }
}
</script>



<style lang="scss">
.item-list {
  display: flex;
  flex-wrap: wrap;
  @include breakpoints-min(md) {
    width: $col-width * 2;
  }
  @include breakpoints-min(lg) {
    margin-top: 16px;
    padding: 0;
  }
  &--no-sidebar {
    @include breakpoints-min(lg) {
      justify-content: center;
      width: $col-width * 3;
    }
  }
}
</style>
